import styled from 'styled-components';

export const ModalStyled = styled.div`
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100vh;
`;

export const ModalBackgroundStyled = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'white';
                    break;
                case 'light':
                    return 'black';
                    break;
                default:
                    return 'black';
            }
        }};
    opacity: .7;
`;

export const ModalBackgroundClickedStyled = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`;

export const ModalWindowStyled = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'black';
                    break;
                case 'light':
                    return 'white';
                    break;
                default:
                    return 'white';
            }
        }};
    z-index: 1000;
    padding: 15px 35px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 768px){
        width: 80%;
    }

    @media screen and (max-width: 576px){
        padding: 15px 25px;
    }
`;

export const CloseWrapperStyled = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Close = styled.button`
    border: none;
    background: none;
    outline: none;
    transition: .3s ease all;
    position: relative;
    left: 25px;
    bottom: 5px;

    & > span {
        font-size: 25px;
        color: grey;
    }

    &:hover {
        opacity: .7;
    }
`;

export const MainStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const MainStyledText = styled.div`
    font-size: 30px;
    margin: 0px 0px 15px 0px;

    & > span {
        font-weight: 500;
        color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'white';
                    break;
                case 'light':
                    return 'black';
                    break;
                default:
                    return 'black';
            }
        }}
    }
`;

export const MainStyledTitle = styled.div` 
    margin: 0px 0px 15px 0px;
    align-self: flex-start;
    text-align: left;
    font-size: 14px;
    color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return '#bebebe';
                    break;
                case 'light':
                    return '#858585';
                    break;
                default:
                    return '#858585';
            }
        }};

    & > span {
        font-style: italic;
    }
`;

export const MainStyledActions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 120px;
`;